function formatYouTubeChannelUrl(url: string): {
  displayName: string
  url: string
} {
  const match = url.match(/youtube\.com\/@(.+)/i)
  if (match && match[1]) {
    return { displayName: `YouTube: @${match[1]}`, url }
  } else {
    return { displayName: "Invalid YouTube URL", url: "" }
  }
}

function formatTwitchChannelUrl(url: string): {
  displayName: string
  url: string
} {
  const match = url.match(/twitch\.tv\/([^\/]+)/i)
  if (match && match[1]) {
    return { displayName: `Twitch: @${match[1]}`, url }
  } else {
    return { displayName: "Invalid Twitch URL", url: "" }
  }
}

type FormatterFunction = (url: string) => { displayName: string; url: string }
const urlFormatters: Record<string, FormatterFunction> = {
  "youtube.com": formatYouTubeChannelUrl,
  "twitch.tv": formatTwitchChannelUrl,
  // Additional formatters can be added here
}

export function formatLiveLinkUrl(url: string): {
  displayName: string
  url: string
} {
  if (!url) return { displayName: "No Live Link", url: "" }

  for (const domain in urlFormatters) {
    if (url.includes(domain)) {
      return urlFormatters[domain](url)
    }
  }

  return { displayName: "Unknown or Invalid URL", url: "" }
}

export const isImageSquare = async (imageUrl: string): Promise<boolean> => {
  if (!imageUrl) {
    return true
  }
  return new Promise((resolve) => {
    const image = new Image()
    image.onload = () => {
      resolve(image.width === image.height)
    }
    image.onerror = () => {
      resolve(false)
    }
    image.src = imageUrl
  })
}
